import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ShieldIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.5 8.875H11.5C10.672 8.875 10 9.463 10 10.187C10 10.912 10.672 11.5 11.5 11.5H12.5C13.328 11.5 14 12.088 14 12.812C14 13.537 13.328 14.125 12.5 14.125H10.5M12 8V8.875M12 14.125V15M11.592 19.905L11.263 19.756C7.562 18.083 4.959 14.652 4.344 10.638L4.037 8.633C3.893 7.693 4.431 6.781 5.324 6.453L11.66 4.127C11.882 4.045 12.126 4.045 12.349 4.127L18.684 6.453C19.577 6.781 20.116 7.693 19.972 8.633L19.665 10.638C19.05 14.652 16.446 18.083 12.746 19.756L12.416 19.905C12.154 20.023 11.854 20.023 11.592 19.905Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

ShieldIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ShieldIcon);
